import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import { $matrixStagesMap } from '../../../models/globalModel/index.js';
import { Link } from 'react-router-dom';
import Button from 'antd/es/button';
import Collapse from 'antd/es/collapse';
import ConfigProvider from 'antd/es/config-provider';
import Space from 'antd/es/space';
import Table from 'antd/es/table';
import Tag from 'antd/es/tag';
import { InfoOutlined } from '@ant-design/icons';
import styles from './Projects.module.css';

export default function Projects({ data }) {
  const stagesMap = useUnit($matrixStagesMap);

  const categorizedData = useMemo(() => {
    if (!data) return {};
    const sorted = {};
    for (const i of Object.values(
      (data ?? [])?.toSorted((a, b) => a.id - b.id)
    )) {
      if (i.category === null) {
        if (sorted['Без категории'] && sorted['Без категории']?.length > 0) {
          sorted['Без категории'].push(i);
        } else {
          sorted['Без категории'] = [i];
        }
      } else if (sorted[i.category] && sorted[i?.category]?.length > 0) {
        sorted[i.category].push(i);
      } else if (!sorted[i.category]) {
        sorted[i.category] = [i];
      }
    }
    return sorted;
  }, [data]);

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Наименование проекта',
      dataIndex: 'name',
      key: 'name',
      width: '20%',
    },
    {
      title: 'Регион',
      dataIndex: 'region',
      key: 'region',
    },
    {
      title: 'Заказчик',
      dataIndex: 'customer',
      key: 'customer',
    },
    {
      title: 'Стоимость проекта млн.тг',
      dataIndex: 'order_amount_with_vat',
      key: 'amount_with_vat',
      render: (val) =>
        !!val && Number.isFinite(val)
          ? new Intl.NumberFormat('ru-Kz', {
              notation: 'standard',
            }).format(val)
          : val ?? '-',
    },
    {
      title: 'Срок реализации',
      dataIndex: 'implementation_period',
      key: 'implementation_period',
    },
    {
      title: 'Ген подрядчик',
      dataIndex: 'general_contractor',
      key: 'supplier',
      render: (val) => val ?? 'Не определен',
    },
    {
      title: 'Стадия проекта',
      dataIndex: 'stage_id',
      key: 'stage',
      render: (stage_id) => (stage_id ? <Tag>{stagesMap[stage_id]}</Tag> : '-'),
    },
    {
      align: 'center',
      dataIndex: 'has_detail',
      render: (dets, record) => {
        return dets ? (
          <Link to={`/matrix/projects/${record.id}`}>
            <Button type="primary" icon={<InfoOutlined />} />
          </Link>
        ) : null;
      },
    },
  ];

  const collapseItems = useMemo(() => {
    if (Object.keys(categorizedData).length === 0) return [];
    return Object.entries(categorizedData).map(([cat, items]) => ({
      key: cat,
      label: <span style={{ color: 'var(--primary)' }}>{cat}</span>,
      children: (
        <Table dataSource={items} columns={columns} pagination={false} />
      ),
    }));
  }, [categorizedData, stagesMap]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: 'var(--primary-bg)',
            contentPadding: 0,
          },
        },
      }}
    >
      <Space direction={'vertical'} style={{ width: '100%', marginTop: 24 }}>
        {collapseItems.map((i) => (
          <Collapse
            key={i.key}
            className={styles.collapse_el}
            bordered={false}
            items={[i]}
            defaultActiveKey={['Без категории']}
          />
        ))}
      </Space>
    </ConfigProvider>
  );
}
